// extracted by mini-css-extract-plugin
export default {"inputJson":"style_inputJson__ubsrb"};